module.exports = {
  validate: function (type, element) {
      if (type == 'email') {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(element).toLowerCase());
      }
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-gk-validator/index.js
// module id = kc+2
// module chunks = 0